/**
* @render react
* @name NumberPlate
*/

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withPolaris } from 'Components/protons/Polaris';

import './_style.scss';

/**
 * NumberPlate component
 *
 * @param {Object} props - the props object
 * @param {string} props.vrm - The vehicle registration mark to be displayed on the number plate
 * @param {Object} props.context - Extra information coming from Polaris provider.
 * @param {Object} props.extraClassNames - Extra class names to be applied to the component
 *
 */
const NumberPlate = (
  {
    vrm,
    extraClassNames,
    context: { cssPrefix },
  },
) => (
  vrm && vrm !== '' ? (
    <div
      className={classNames({
        [`${cssPrefix}__number-plate`]: true,
        ...extraClassNames,
      })}
    >
      {vrm}
    </div>
  ) : null
);

/**
 * Valid props
 */
NumberPlate.propTypes = {
  vrm: PropTypes.string,
  context: PropTypes.shape(),
  extraClassNames: PropTypes.shape(),
};

/**
 * Default props
 */
NumberPlate.defaultProps = {
  vrm: '',
  context: {},
  extraClassNames: {},
};

export default withPolaris(NumberPlate);
